import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { useLanguage } from '../contexts/LanguageContext';
import { apiService } from '../services/api';

const QuoteSection = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: ''
  });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      await apiService.createQuote(formData);
      
      toast({
        title: t('quote.success'),
        description: t('quote.successMsg'),
      });
      
      setFormData({ name: '', company: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast({
        title: 'Hata',
        description: 'Form gönderilemedi. Lütfen tekrar deneyin.',
        variant: 'destructive',
      });
    } finally {
      setSending(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="quote" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#36344D] mb-4">
              {t('quote.title')}
            </h2>
            <p className="text-lg text-gray-600">
              {t('quote.subtitle')}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="bg-gray-50 p-8 lg:p-12 rounded-xl shadow-lg">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-[#36344D] font-semibold mb-2">
                  {t('quote.name')} *
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#DF6A6A] focus:border-transparent"
                  placeholder={t('quote.namePlaceholder')}
                />
              </div>
              <div>
                <label className="block text-[#36344D] font-semibold mb-2">
                  {t('quote.company')} *
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#DF6A6A] focus:border-transparent"
                  placeholder={t('quote.companyPlaceholder')}
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-[#36344D] font-semibold mb-2">
                  {t('quote.email')} *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#DF6A6A] focus:border-transparent"
                  placeholder={t('quote.emailPlaceholder')}
                />
              </div>
              <div>
                <label className="block text-[#36344D] font-semibold mb-2">
                  {t('quote.phone')} *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#DF6A6A] focus:border-transparent"
                  placeholder={t('quote.phonePlaceholder')}
                />
              </div>
            </div>

            <div className="mb-6">
              <label className="block text-[#36344D] font-semibold mb-2">
                {t('quote.message')} *
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#DF6A6A] focus:border-transparent resize-none"
                placeholder={t('quote.messagePlaceholder')}
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={sending}
              className="w-full bg-[#DF6A6A] text-white py-4 rounded-md hover:bg-[#c55555] transition-colors duration-300 font-semibold flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <span>{sending ? 'Gönderiliyor...' : t('quote.submit')}</span>
              <Send className="w-5 h-5" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;